module.exports = __webpack_public_path__ + "img/Image 52.f76f8daf.png";